import Icon from '../components/Icon.vue'

Icon.register({
  bolt: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M296 160H180.6L223.2 30.2C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8L0.2 260.8C-1.7 275.2 9.5 288 24 288H142.7L96.6 482.5C93 497.7 104.6 512 119.9 512 128.3 512 136.3 507.6 140.7 500L316.7 196C326 180.1 314.5 160 296 160z'
      }
    ]
  }
})
